import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { animated, config, Transition } from "react-spring";
import { getVehicleThumbnail, getVehicleTitle } from "src/store/selectors/vehicles";
import { AccountState, ApplicationStore } from "Types/state";
import "./CustomizePaymentHeader.scss";
import DealerInfo from "./DealerInfo";
import DealVehicleInfo from "./DealVehicleInfo";

interface CustomizePaymentHeaderProps {
    account: AccountState;
    accountDisplayed: boolean;
    calculatedPaymentRenderer?: () => ReactNode;
    vin: string;
    fixed: boolean;
    style?: any;
}

class CustomizePaymentHeader extends Component<CustomizePaymentHeaderProps & ReturnType<typeof mapStateToProps>> {
    public render() {
        const { accountDisplayed, calculatedPaymentRenderer, fixed, style } = this.props;
        const elements = accountDisplayed
            ? calculatedPaymentRenderer
                ? [this.getVehicleInfoItem(), this.getPaymentItem()]
                : [this.getDealerInfoItem(), this.getVehicleInfoItem()]
            : [this.getVehicleInfoItem(), this.getPaymentItem()];
        const getItemKeys = (item: any) => item.key;

        function onEnterStyles({ item, key }: { item: React.ReactNode; key: string }) {
            const width = key === "vehicleInfo" ? "365px" : key === "dealerInfo" ? "285px" : "255px";

            return [{ opacity: 1, ...(accountDisplayed && { width }), transform: "scale(1)" }];
        }

        return (
            <div className={`${!!fixed && "sticky"} CustomizePaymentHeader`} style={style}>
                <Transition
                    native
                    items={elements}
                    keys={getItemKeys}
                    initial={null}
                    from={{ opacity: 0, width: accountDisplayed ? "255px" : "0%", transform: "scale(0)" }}
                    enter={onEnterStyles}
                    leave={[{ opacity: 0, width: accountDisplayed ? "0px" : "0%", transform: "scale(0)" }]}
                    config={config.default}
                >
                    {(item) => (props) => (
                        <animated.div className="CustomizePaymentHeader__item" style={props} children={item.item} />
                    )}
                </Transition>
            </div>
        );
    }

    public getDealerInfoItem = () => {
        const { account } = this.props;
        return {
            item: <DealerInfo logo={account.logo_splash} />,
            key: "dealerInfo",
        };
    };

    public getVehicleInfoItem = () => {
        return {
            item: <DealVehicleInfo thumbnail={this.props.thumbnail!} title={this.props.title} vin={this.props.vin} />,
            key: "vehicleInfo",
        };
    };

    public getPaymentItem = () => {
        const { calculatedPaymentRenderer } = this.props;
        return {
            item: calculatedPaymentRenderer && calculatedPaymentRenderer(),
            key: "payment",
        };
    };
}

function mapStateToProps(state: ApplicationStore, { vin }: CustomizePaymentHeaderProps) {
    return {
        thumbnail: getVehicleThumbnail(state, vin),
        title: getVehicleTitle(state, vin),
    };
}

export default connect(mapStateToProps, undefined, undefined, { forwardRef: true })(CustomizePaymentHeader);
